"use strict";

/*;
	@module-license:
		The MIT License (MIT)
		@mit-license

		Copyright (@c) 2017 Richeve Siodina Bebedor
		@email: richeve.bebedor@gmail.com

		Permission is hereby granted, free of charge, to any person obtaining a copy
		of this software and associated documentation files (the "Software"), to deal
		in the Software without restriction, including without limitation the rights
		to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
		copies of the Software, and to permit persons to whom the Software is
		furnished to do so, subject to the following conditions:

		The above copyright notice and this permission notice shall be included in all
		copies or substantial portions of the Software.

		THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
		IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
		FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
		AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
		LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
		OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
		SOFTWARE.
	@end-module-license

	@module-configuration:
		{
			"package": "arkount",
			"path": "arkount/arkount.js",
			"file": "arkount.js",
			"module": "arkount",
			"author": "Richeve S. Bebedor",
			"contributors": [
				"John Lenon Maghanoy <johnlenonmaghanoy@gmail.com>"
			],
			"eMail": "richeve.bebedor@gmail.com",
			"repository": "https://github.com/volkovasystems/arkount.git",
			"test": "arkount-test.js",
			"global": true
		}
	@end-module-configuration

	@module-documentation:
		Safe array element count.
	@end-module-documentation

	@include:
		{
			"doubt": "doubt",
			"raze": "raze",
			"truly": "truly",
			"wichevr": "wichevr"
		}
	@end-include
*/

const doubt = require( "doubt" );
const raze = require( "raze" );
const truly = require( "truly" );
const wichevr = require( "wichevr" );

const arkount = function arkount( array ){
	/*;
		@meta-configuration:
			{
				"array:required": "[*]"
			}
		@end-meta-configuration
	*/

	if( !doubt( array, AS_ARRAY ) ){
		return 0;
	}

	return wichevr( raze( array ).filter( truly ).length, 0 );
};

module.exports = arkount;



// WEBPACK FOOTER //
// arkount.js